import { categories } from "@/mocks/media";

export default function AboutBand() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-5">
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-600">ABOUT 51</p>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
              把每一口瓜，<br className="hidden sm:block" />吃出该有的态度
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-foreground-600 leading-relaxed">
              从幕后视角出发，我们不贩卖猎奇，只呈现事实的多面。通过持续更新与深度专题，陪你把娱乐八卦聊得明白、看得透彻。
            </p>
          </div>
          <div className="lg:col-span-3 grid grid-cols-3 gap-3">
            <div className="rounded-lg bg-background-50 border border-background-200 p-3 text-center">
              <p className="font-heading text-xl font-bold text-primary-600">6</p>
              <p className="mt-1 text-xs text-foreground-500">吃瓜栏目</p>
            </div>
            <div className="rounded-lg bg-background-50 border border-background-200 p-3 text-center">
              <p className="font-heading text-xl font-bold text-primary-600">日更</p>
              <p className="mt-1 text-xs text-foreground-500">滚动跟进</p>
            </div>
            <div className="rounded-lg bg-background-50 border border-background-200 p-3 text-center">
              <p className="font-heading text-xl font-bold text-primary-600">多维</p>
              <p className="mt-1 text-xs text-foreground-500">交叉核实</p>
            </div>
          </div>
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          {categories.map((c) => (
            <a
              key={c.key}
              href={`#${c.key}`}
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 border border-background-200 text-xs text-foreground-700 hover:border-primary-400 hover:text-primary-600 whitespace-nowrap"
            >
              <i className={c.icon}></i> {c.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}